<script type="text/javascript">
  export default {
    props: ['type', 'pc', 'slug', 'website'],
    data() {
      return {
        default_content: {
          type: 'store',
          title: 'Store',
          active: 1,
          image: '',
          color: 'gray-100',
          opacity: '',
          pad_t: '5',
          pad_r: '0',
          pad_b: '10',
          pad_l: '0',
          icon: '',
          icon_color: '',
          h2: '',
          h2_color: '',
          h2_desc: '',
          h2_desc_color: '',
          pre_btn: [],

          main_bg_color: 'white',
          main_border_color: '',
          main_title: 'Interested?',
          main_title_color: 'black',
          main_desc: "If you're interested fill out the form below and we will send you additional details.",
          main_text_color: 'muted',
          main_btn_color: 'revinre',
          main_btn_pre_icon: 'ri:mail-send-line',
          main_btn_text: 'Submit',
          main_btn_post_icon: '',
          main_icon: 'ri:building-4-line',
          main_icon_color: 'revinre',
          main_image: '/storage/fm/revinre-nc/clip art/Contact Preferred Partner.png',

          loc_active: 1,
          loc_icon: 'ri:road-map-line',
          loc_top_bg_color: 'dark',
          loc_top_text_color: 'white',
          loc_bg_color: 'white',
          loc_text_color: 'black',

          cat_active: 1,
          cat_icon: 'ri:price-tag-3-line',
          cat_top_bg_color: 'dark',
          cat_top_text_color: 'white',
          cat_bg_color: 'white',
          cat_text_color: 'black',

          post_btn: [],
        },

        cart: [],

        default_cart_item: {
          id: '',
          title: '',
          description: '',
          price: '',
          quantity: '1',
          size: '',
          color: '',
          thumbnail: '',
        },
        cart_item: {},

        view: false,
        viewing: {},

        loading: true,
        results: [
          {
            title: "Wireless charging station",
            price: "20",
            thumbnail: "/fm/revinre-store/clip art/item_1.png",
            images: ["/fm/revinre-store/clip art/item_1.png", "/fm/revinre-store/clip art/item_1.png", "/fm/revinre-store/clip art/item_1.png"],
            description: "Customize how you buy and sell your home and receive the benefits that matter to you.",
            colors: ["#7ac5c5", "#cf7e7e", "#e3a463"],
            sizes: ["small", "medium", "large"],
          },
          {
            title: "TikTak",
            price: "20",
            thumbnail: "/fm/revinre-store/clip art/item_2.png",
            images: ["/fm/revinre-store/clip art/item_2.png", "/fm/revinre-store/clip art/item_2.png", "/fm/revinre-store/clip art/item_2.png"],
            description: "Customize how you buy and sell your home and receive the benefits that matter to you.",
            colors: ["#7ac5c5", "#cf7e7e", "#e3a463"],
            sizes: ["small", "medium", "large"],
          },
          {
            title: "Backpack",
            price: "20",
            thumbnail: "/fm/revinre-store/clip art/item_3.png",
            images: ["/fm/revinre-store/clip art/item_3.png", "/fm/revinre-store/clip art/item_3.png", "/fm/revinre-store/clip art/item_3.png"],
            description: "Customize how you buy and sell your home and receive the benefits that matter to you.",
            colors: ["#7ac5c5", "#cf7e7e", "#e3a463"],
            sizes: ["small", "medium", "large"],
          },
          {
            title: "Backpack",
            price: "20",
            thumbnail: "/fm/revinre-store/clip art/item_4.png",
            images: ["/fm/revinre-store/clip art/item_4.png", "/fm/revinre-store/clip art/item_4.png", "/fm/revinre-store/clip art/item_4.png"],
            description: "Customize how you buy and sell your home and receive the benefits that matter to you.",
            colors: ["#7ac5c5", "#cf7e7e", "#e3a463"],
            sizes: ["small", "medium", "large"],
          },
          {
            title: "T-shirt",
            price: "20",
            thumbnail: "/fm/revinre-store/clip art/item_5.png",
            images: ["/fm/revinre-store/clip art/item_5.png", "/fm/revinre-store/clip art/item_5.png", "/fm/revinre-store/clip art/item_5.png"],
            description: "Customize how you buy and sell your home and receive the benefits that matter to you.",
            colors: ["#7ac5c5", "#cf7e7e", "#e3a463"],
            sizes: ["small", "medium", "large"],
          },
          {
            title: "Bottle Opener",
            price: "20",
            thumbnail: "/fm/revinre-store/clip art/item_6.png",
            images: ["/fm/revinre-store/clip art/item_6.png", "/fm/revinre-store/clip art/item_6.png", "/fm/revinre-store/clip art/item_6.png"],
            description: "Customize how you buy and sell your home and receive the benefits that matter to you.",
            colors: ["#7ac5c5", "#cf7e7e", "#e3a463"],
            sizes: ["small", "medium", "large"],
          },
          {
            title: "Flashlight",
            price: "20",
            thumbnail: "/fm/revinre-store/clip art/item_7.png",
            images: ["/fm/revinre-store/clip art/item_7.png", "/fm/revinre-store/clip art/item_7.png", "/fm/revinre-store/clip art/item_7.png"],
            description: "Customize how you buy and sell your home and receive the benefits that matter to you.",
            colors: ["#7ac5c5", "#cf7e7e", "#e3a463"],
            sizes: ["small", "medium", "large"],
          },
          {
            title: "Polo Shirt",
            price: "20",
            thumbnail: "/fm/revinre-store/clip art/item_8.png",
            images: ["/fm/revinre-store/clip art/item_8.png", "/fm/revinre-store/clip art/item_8.png", "/fm/revinre-store/clip art/item_8.png"],
            description: "Customize how you buy and sell your home and receive the benefits that matter to you.",
            colors: ["#7ac5c5", "#cf7e7e", "#e3a463"],
            sizes: ["small", "medium", "large"],
          },
          {
            title: "Baseball cap",
            price: "20",
            thumbnail: "/fm/revinre-store/clip art/item_9.png",
            images: ["/fm/revinre-store/clip art/item_9.png", "/fm/revinre-store/clip art/item_9.png", "/fm/revinre-store/clip art/item_9.png"],
            description: "Customize how you buy and sell your home and receive the benefits that matter to you.",
            colors: ["#7ac5c5", "#cf7e7e", "#e3a463"],
            sizes: ["small", "medium", "large"],
          },
          {
            title: "Baseball cap",
            price: "20",
            thumbnail: "/fm/revinre-store/clip art/item_10.png",
            images: ["/fm/revinre-store/clip art/item_10.png", "/fm/revinre-store/clip art/item_10.png", "/fm/revinre-store/clip art/item_10.png"],
            description: "Customize how you buy and sell your home and receive the benefits that matter to you.",
            colors: ["#7ac5c5", "#cf7e7e", "#e3a463"],
            sizes: ["small", "medium", "large"],
          },
          {
            title: "Insulated Mug",
            price: "20",
            thumbnail: "/fm/revinre-store/clip art/item_11.png",
            images: ["/fm/revinre-store/clip art/item_11.png", "/fm/revinre-store/clip art/item_11.png", "/fm/revinre-store/clip art/item_11.png"],
            description: "Customize how you buy and sell your home and receive the benefits that matter to you.",
            colors: ["#7ac5c5", "#cf7e7e", "#e3a463"],
            sizes: ["small", "medium", "large"],
          },
          {
            title: "Insulated Mug",
            price: "20",
            thumbnail: "/fm/revinre-store/clip art/item_12.png",
            images: ["/fm/revinre-store/clip art/item_12.png", "/fm/revinre-store/clip art/item_12.png", "/fm/revinre-store/clip art/item_12.png"],
            description: "Customize how you buy and sell your home and receive the benefits that matter to you.",
            colors: ["#7ac5c5", "#cf7e7e", "#e3a463"],
            sizes: ["small", "medium", "large"],
          },
          {
            title: "Wireless charging mousepad",
            price: "20",
            thumbnail: "/fm/revinre-store/clip art/item_13.png",
            images: ["/fm/revinre-store/clip art/item_13.png", "/fm/revinre-store/clip art/item_13.png", "/fm/revinre-store/clip art/item_13.png"],
            description: "Customize how you buy and sell your home and receive the benefits that matter to you.",
            colors: ["#7ac5c5", "#cf7e7e", "#e3a463"],
            sizes: ["small", "medium", "large"],
          }
        ],
        pagination: {},
        filters: {
          paginate: 1000,
          page: 1,
          total: 0,
        },

        search: '',
        categories: [],
        seen: [],
        message_sent: [],
        contactform: {
          name: '',
          email: '',
          phone: '',
          vendor: '',
          comments: "I would like more information on this please!",
          // buying: false,
          // has_realtor: false,
          recaptcha_token: '',
        },
      }
    },
    watch: {
      'filters.paginate': { handler: function(n, o) { this.pagination.current_page = 1; this.fetchData(); }},
    },
    computed: {
      computedResults() {
        console.log('computedResults');
        var results = [], a_categories = [];

        var categories_allfalse = true; for(var i in this.categories) { if(this.categories[i].active) { categories_allfalse = false; a_categories.push(this.categories[i].name); } }

        for(var i in this.results) {
          if((categories_allfalse || this.results[i].categories.some(r=> a_categories.includes(r))) &&
            (!this.search || JSON.stringify(this.results[i]).toLowerCase().includes(this.search.toLowerCase()))
          ) {
            results.push(this.results[i]);
          }
        }
        return results;
      },
    },
    created() {
      if(this.pc && this.pc.init == 'Yes') { for(var i in this.default_content) { this.pc[i] = this.default_content[i]; } this.pc.init = ''; }
      if(!this.pc.pre_btn) { this.pc.pre_btn = []; this.$forceUpdate(); }
      if(!this.pc.post_btn) { this.pc.post_btn = []; this.$forceUpdate(); }

      if(this.type != 'editor') {
        this.cart_item = JSON.parse(JSON.stringify(this.default_cart_item));
        
        this.categories = [];
        if(this.website['store_categories']) { for(var i in this.website['store_categories']) {
          this.categories.push({id: (i + 1), name: this.website['store_categories'][i], active: false});
        } }

        this.fetchData();
        this.loading = false;
      }
    },
    mounted() {
      var parent = document.getElementById('navbarCollapse');
      var child = parent.querySelector('.navbar-nav.ml-auto.navbar-center'); // Or use any appropriate selector for the child

      if(child) {
        console.log('Child element exists!');
        let newLi = document.createElement('li');
        newLi.classList.add('nav-item');
        newLi.innerHTML = '<a id="cart_menu" href="#" class="nav-link">View Cart</a>'; 
        child.prepend(newLi);
      } else {
        console.log('Child element does not exist.');
        let newParentUl = document.createElement('ul');
        newParentUl.classList.add('navbar-nav', 'ml-auto', 'navbar-center');
        newParentUl.innerHTML = '<li class="nav-item"><a id="cart_menu" href="#" class="nav-link">View Cart</a></li>'; 
        parent.append(newParentUl);
      }
    },
    methods: {
      fetchData() {
        this.loading = true;
        this.filters.page = this.pagination.current_page;
        this.$http.get('/stores/fetch', {params: this.filters}).then(res => {
          console.log(res);
          this.results = res.data.data;
          this.pagination = res.data;
          this.filters.total = res.data.total;
          this.loading = false;
        }).catch(res => {
          this.loading = false;
          // this.$noty.warning("There was an error loading the required data. Please try again and contact support if the problem persists.");
        });
      },
      openDetails(product) {
        this.cart_item = JSON.parse(JSON.stringify(this.default_cart_item));
        this.cart_item.id = product.id;
        this.cart_item.title = product.title;
        this.cart_item.description = product.description;
        this.cart_item.price = product.price;
        this.cart_item.thumbnail = product.thumbnail;
        this.viewing = product;
        this.view = true;
        $('body').addClass("no-scroll-page");
      },
      closeDetails() {
        this.cart_item = JSON.parse(JSON.stringify(this.default_cart_item));
        this.viewing = {};
        this.view = false;
        $('body').removeClass("no-scroll-page");
      },
    }
  }
</script>

<template>
  <section>

    <div v-if="type == 'editor'">
      <div class="p-3">
        <div class="row">
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" v-model="pc.active" Title="Active :" :Options="[{name:'Yes',value:1},{name:'No',value:0}]" v-tippy content="Display this section on the live website?"></w-field>
          </div>
        </div>
        <h6 class="section-header mt-3"><Icon icon="ri:book-2-line"></Icon> Section background and padding :</h6>
        <div class="row">
          <div class="col-sm-4">
            <w-field SimpleDataType="String" v-model="pc.image" Title="Background image URL :"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" Title="Background color :" :Options="theme_colors" v-model="pc.color"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="Number" v-model="pc.opacity" Min="0" Max="10" Title="Background color opacity :" v-tippy content="Background color transparency (0 through 10)"></w-field>
          </div>
          <div class="col-sm-3">
            <w-field SimpleDataType="Number" v-model="pc.pad_t" Min="0" Max="20" Title="Top padding :" v-tippy content="Padding for the top of the section (0 through 20)"></w-field>
          </div>
          <div class="col-sm-3">
            <w-field SimpleDataType="Number" v-model="pc.pad_r" Min="0" Max="20" Title="Right padding :" v-tippy content="Padding for the right of the section (0 through 20)"></w-field>
          </div>
          <div class="col-sm-3">
            <w-field SimpleDataType="Number" v-model="pc.pad_b" Min="0" Max="20" Title="Bottom padding :" v-tippy content="Padding for the bottom of the section (0 through 20)"></w-field>
          </div>
          <div class="col-sm-3">
            <w-field SimpleDataType="Number" v-model="pc.pad_l" Min="0" Max="20" Title="Left padding :" v-tippy content="Padding for the left of the section (0 through 20)"></w-field>
          </div>
        </div>
        <h6 class="section-header mt-3"><Icon icon="ri:book-2-line"></Icon> Section H2 title :</h6>
        <div class="row">
          <div class="col-sm-6">
            <w-field SimpleDataType="String" v-model="pc.icon" Title="Section icon :" v-tippy content="Section icon"></w-field>
          </div>
          <div class="col-sm-6">
            <w-field SimpleDataType="String List, Single" v-model="pc.icon_color" Title="Section icon color : " :Options="theme_colors"></w-field>
          </div>
          <div class="col-sm-6">
            <w-field SimpleDataType="String" v-model="pc.h2" Title="H2 title :" v-tippy content="Section title"></w-field>
          </div>
          <div class="col-sm-6">
            <w-field SimpleDataType="String List, Single" v-model="pc.h2_color" Title="H2 title color : " :Options="theme_colors"></w-field>
          </div>
          <div class="col-sm-6">
            <w-field SimpleDataType="Textarea" v-model="pc.h2_desc" Title="H2 description :" v-tippy content="Section description appearing below the section title"></w-field>
          </div>
          <div class="col-sm-6">
            <w-field SimpleDataType="String List, Single" v-model="pc.h2_desc_color" Title="H2 description color : " :Options="theme_colors"></w-field>
          </div>
        </div>

        <h6 class="section-header mt-3"><Icon icon="ri:book-2-line"></Icon> Top buttons :</h6>
        <div class="form-group">
          <draggable handle=".handle" v-bind="{animation: 200}" v-model="pc.pre_btn">
            <transition-group tag="div">
              <div v-for="(btn, btn_i) in pc.pre_btn" :key="'f1'+btn_i">
                <div class="row m-0 align-items-end">
                  <div class="col-2 p-0">
                    <w-field SimpleDataType="String" v-model="btn.pre_icon" Title="Pre icon :"></w-field>
                  </div>
                  <div class="col-2 p-0">
                    <w-field SimpleDataType="String" v-model="btn.text" Title="Text :"></w-field>
                  </div>
                  <div class="col-2 p-0">
                    <w-field SimpleDataType="String" v-model="btn.post_icon" Title="Post icon :"></w-field>
                  </div>
                  <div class="col-2 p-0">
                    <w-field SimpleDataType="String List, Single" v-model="btn.color" Title="Color : " :Options="theme_colors"></w-field>
                  </div>
                  <div class="col p-0">
                    <w-field SimpleDataType="String" v-model="btn.url" Title="URL :"></w-field>
                  </div>
                  <div class="_w-40 pb-2">
                    <button class="btn btn-white" type="button" v-tippy content="Delete" @click="pc.pre_btn.splice(btn_i, 1); $forceUpdate()"><Icon icon="ri:delete-bin-line"></Icon></button>
                  </div>
                  <div class="_w-40 pb-2">
                    <button class="btn btn-white handle" type="button" v-tippy content="Drag to arrange"><Icon icon="ri:drag-move-2-fill"></Icon></button>
                  </div>
                </div>
              </div>
            </transition-group>
          </draggable>
          <button class="btn btn-sm btn-primary" type="button" @click="pc.pre_btn.push({color: '', pre_icon: '', text: '', post_icon: '', url: ''}); $forceUpdate()"><Icon icon="ri:add-line" height="18"></Icon> Add button</button>
        </div>

        <h6 class="section-header mt-3"><Icon icon="ri:book-2-line"></Icon> Details Box :</h6>
        <div class="row">
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" Title="Background color :" :Options="theme_colors" v-model="pc.main_bg_color"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" Title="Section border color :" :Options="theme_colors" v-model="pc.main_border_color"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" v-model="pc.main_title_color" Title="Title color : " :Options="theme_colors"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" v-model="pc.main_text_color" Title="Text color : " :Options="theme_colors"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" v-model="pc.main_btn_color" Title="Button color : " :Options="theme_colors"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String" v-model="pc.main_btn_pre_icon" Title="Button pre icon :"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String" v-model="pc.main_btn_text" Title="Button text :"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String" v-model="pc.main_btn_post_icon" Title="Button post icon :"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String" v-model="pc.main_icon" Title="Form icon :"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" v-model="pc.main_icon_color" Title="Form icon color : " :Options="theme_colors"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String" v-model="pc.main_title" Title="Form title :"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String" v-model="pc.main_desc" Title="Form description :"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String" v-model="pc.main_image" Title="Form image :"></w-field>
          </div>
        </div>
        
        <h6 class="section-header mt-3"><Icon icon="ri:book-2-line"></Icon> Location box :</h6>
        <div class="row">
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" v-model="pc.loc_active" Title="Active :" :Options="[{name:'Yes',value:1},{name:'No',value:0}]" v-tippy content="Display the blog categories selection field on the right of the blog?"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String" v-model="pc.loc_icon" Title="Categories icon :"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" Title="Top background color :" :Options="theme_colors" v-model="pc.loc_top_bg_color"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" Title="Top text color :" :Options="theme_colors" v-model="pc.loc_top_text_color"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" Title="Bottom background color :" :Options="theme_colors" v-model="pc.loc_bg_color"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" Title="Bottom text color :" :Options="theme_colors" v-model="pc.loc_text_color"></w-field>
          </div>
        </div>
        
        <h6 class="section-header mt-3"><Icon icon="ri:book-2-line"></Icon> Category box :</h6>
        <div class="row">
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" v-model="pc.cat_active" Title="Active :" :Options="[{name:'Yes',value:1},{name:'No',value:0}]" v-tippy content="Display the blog categories selection field on the right of the blog?"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String" v-model="pc.cat_icon" Title="Categories icon :"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" Title="Top background color :" :Options="theme_colors" v-model="pc.cat_top_bg_color"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" Title="Top text color :" :Options="theme_colors" v-model="pc.cat_top_text_color"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" Title="Bottom background color :" :Options="theme_colors" v-model="pc.cat_bg_color"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" Title="Bottom text color :" :Options="theme_colors" v-model="pc.cat_text_color"></w-field>
          </div>
        </div>

        <h6 class="section-header mt-3"><Icon icon="ri:book-2-line"></Icon> Bottom buttons :</h6>
        <div class="form-group">
          <draggable handle=".handle" v-bind="{animation: 200}" v-model="pc.post_btn">
            <transition-group tag="div">
              <div v-for="(btn, btn_i) in pc.post_btn" :key="'f2'+btn_i">
                <div class="row m-0 align-items-end">
                  <div class="col-2 p-0">
                    <w-field SimpleDataType="String" v-model="btn.pre_icon" Title="Pre icon :"></w-field>
                  </div>
                  <div class="col-2 p-0">
                    <w-field SimpleDataType="String" v-model="btn.text" Title="Text :"></w-field>
                  </div>
                  <div class="col-2 p-0">
                    <w-field SimpleDataType="String" v-model="btn.post_icon" Title="Post icon :"></w-field>
                  </div>
                  <div class="col-2 p-0">
                    <w-field SimpleDataType="String List, Single" v-model="btn.color" Title="Color : " :Options="theme_colors"></w-field>
                  </div>
                  <div class="col p-0">
                    <w-field SimpleDataType="String" v-model="btn.url" Title="URL :"></w-field>
                  </div>
                  <div class="_w-40 pb-2">
                    <button class="btn btn-white" type="button" v-tippy content="Delete" @click="pc.post_btn.splice(btn_i, 1); $forceUpdate()"><Icon icon="ri:delete-bin-line"></Icon></button>
                  </div>
                  <div class="_w-40 pb-2">
                    <button class="btn btn-white handle" type="button" v-tippy content="Drag to arrange"><Icon icon="ri:drag-move-2-fill"></Icon></button>
                  </div>
                </div>
              </div>
            </transition-group>
          </draggable>
          <button class="btn btn-sm btn-primary" type="button" @click="pc.post_btn.push({color: '', pre_icon: '', text: '', post_icon: '', url: ''}); $forceUpdate()"><Icon icon="ri:add-line" height="18"></Icon> Add button</button>
        </div>

      </div>
    </div>

    <div v-else class="container-fluid">






      <transition name="fade">
        <div v-if="view" class="position-fixed _pos-l-0 _pos-t-0 _pos-r-0 _pos-b-0 _bg-c-t-000-5 _z-2000">
          <div class="py-5 px-0 px-md-3 h-100 overflow-auto" @click.self="closeDetails()">
            <div class="container-fluid">
              <div class="bg-white _box-shadow-0-1-10-b-2 rounded">
                <div class="float-right">
                  <button type="button" class="btn btn-lg btn-white border-0" @click="closeDetails()"><Icon icon="ri:close-line" width="30"></Icon></button>
                </div>
                <div class="p-5">
                  <div class="row">
                    <div class="col-sm-5">
                      <w-image-slider v-if="viewing.images && viewing.images.length" :images="viewing.images"></w-image-slider>
                    </div>
                    <div class="col-sm-6 offset-sm-1">
                      <div class="font-weight-bold _f-s-30">{{ viewing.title }}</div>
                      <div class="font-weight-bold _f-s-25">{{ formatPrice(viewing.price) }}</div>
                      <hr class="my-4 border-light">
                      <div class="mb-3">
                        <label class="_f-s-15 mb-2">Color:</label>
                        <div class="mb-2">
                          <span v-for="(color, color_i) in viewing.colors" :key="color_i" class="p-2 mr-2 d-inline-block rounded-circle" :style="'background-color:'+color"></span>
                        </div>
                      </div>
                      <div class="mb-3">
                        <label class="_f-s-15 mb-2">Size:</label>
                        <w-field SimpleDataType="String List, Single" :Options="viewing.sizes" v-model="cart_item.size" placeholder="Select..."></w-field>
                      </div>
                      <div class="mb-3">
                        <label class="_f-s-15 mb-2">Quantity:</label>
                        <input type="number" class="form-control" min="0" step="any" v-model="cart_item.quantity">
                      </div>
                      <button class="btn btn-revinre"><Icon icon="ri:shopping-basket-2-line" class="m-0" /> Add to cart</button>
                    </div>
                  </div>
                  <hr class="my-4 border-light">
                  <div class="_f-s-25 font-weight-bold">Product Description:</div>
                  <p v-html="viewing.description"></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>







      <div class="position-absolute _pos-l-0 _pos-t-0 _pos-r-0 _pos-b-0 _z-n1 _bg-repeat-none _bg-size-cover _bg-position-center" :style="'background-image: url('+(pc['image'] ? fullurlencode(pc['image']) : '')+')'"></div>
      <div class="position-absolute _pos-l-0 _pos-t-0 _pos-r-0 _pos-b-0 _z-n1" :class="'bg-'+pc['color']+' _o-'+pc['opacity']"></div>
      <div class="container-fluid m_py-35" :class="'pt-'+pc['pad_t']+' pr-'+pc['pad_r']+' pb-'+pc['pad_b']+' pl-'+pc['pad_l']">

        <div v-if="pc['icon'] || pc['h2'] || pc['h2_desc']" class="text-center _w-m-900 mx-auto mb-5">
          <Icon v-if="pc['icon']" :icon="pc['icon']" height="45" class="mb-2" :class="'text-'+pc['icon_color']"></Icon>
          <h2 v-if="pc['h2']" class="mb-3" :class="'text-'+pc['h2_color']" data-aos="fade-zoom-in">{{pc['h2']}}</h2>
          <p v-if="pc['h2_desc']" :class="'text-'+pc['h2_desc_color']" data-aos="fade-zoom-in">{{pc['h2_desc']}}</p>
        </div>

        <div v-if="pc['pre_btn'] && pc['pre_btn'].length" class="text-center mb-5">
          <a v-for="(btn, btn_i) in pc['pre_btn']" :key="btn_i" v-if="btn['text'] || btn['pre_icon'] || btn['post_icon']" class="btn btn-lg mb-3 mx-3" :class="'btn-'+btn['color']" :href="btn['url']" target="_blank">
            <Icon v-if="btn['pre_icon']" :icon="btn['pre_icon']" height="20"></Icon>
            <span v-if="btn['pre_icon'] && btn['text']" class="border-left mx-3"></span>
            {{ btn['text'] }}
            <span v-if="btn['post_icon'] && btn['text']" class="border-left mx-3"></span>
            <Icon v-if="btn['post_icon']" :icon="btn['post_icon']" height="20"></Icon>
          </a>
        </div>

        <div v-if="loading && !computedResults.length" class="row">
          <div v-if="pc['cat_active'] || pc['loc_active']" class="col-sm-3">
            <div v-if="pc['cat_active']">
              <ul class="nav flex-column rounded" :class="'bg-'+pc['loc_top_bg_color']+' text-'+pc['loc_top_text_color']">
                <li class="nav-item p-3 m-0 rounded-top"><Icon class="mr-2" :icon="pc['loc_icon']" /> Categories</li>
              </ul>
              <div class="_h-m-500 overflowy-auto mb-4">
                <ul class="nav flex-column rounded" :class="'bg-'+pc['loc_bg_color']">
                  <li v-for="c_i in 19" :key="c_i" class="nav-item">
                    <div class="nav-link py-2 border-top border-light" :class="'text-'+pc['cat_text_color']"><div class="ph" style="height: 20px;"></div></div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div :class="'col-sm-'+(pc['cat_active'] || pc['loc_active'] ? 9 : 12)">
            <div v-for="c_i in 3" :key="c_i" class="card mb-4" :class="'bg-'+pc['main_bg_color']">
              <div class="card-header p-0" :class="'bg-'+pc['main_bg_color']">
                <div class="p-3">
                  <Icon icon="ri:arrow-down-s-line" class="float-right _f-s-30 _lh-30" />
                  <div class="row m-0">
                    <div class="_w-180">
                      <div class="ph _h-120 rounded"></div>
                    </div>
                    <div class="col">
                      <div class="ph mb-2" style="height: 40px;"></div>
                      <div class="ph mb-2" style="height: 20px;"></div>
                      <div class="ph mb-2" style="height: 20px;"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div v-if="!loading" class="row">
          <div v-if="pc['cat_active'] || pc['loc_active']" class="col-sm-3">
            <div v-if="pc['cat_active']">
              <ul class="nav flex-column rounded" :class="'bg-'+pc['cat_top_bg_color']+' text-'+pc['cat_top_text_color']">
                <li class="nav-item p-3 m-0 rounded-top"><Icon class="mr-2" :icon="pc['cat_icon']" /> Categories</li>
              </ul>
              <div class="_h-m-500 overflowy-auto mb-5">
                <ul class="nav flex-column rounded" :class="'bg-'+pc['cat_bg_color']">
                  <li v-if="categories" v-for="(cat, cat_i) in categories" :key="cat_i" class="nav-item">
                    <div class="nav-link py-2 active border-top border-light" :class="'text-'+pc['cat_text_color']" @click="cat.active ? cat.active = false : cat.active = true">
                      <p-check class="p-default p-curve p-smooth w-100" color="success-o" v-model="cat.active"><span class="ml-2">{{ cat.name }}</span></p-check>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div :class="'col-sm-'+(pc['cat_active'] || pc['loc_active'] ? 9 : 12)">

            <div class="mb-4">
              <div class="input-group">
                <input class="form-control py-2 border-right-0 border-light _h-50" type="search" placeholder="Search for content..." v-model="search">
                <span class="input-group-append">
                  <div class="input-group-text bg-white border-light"><Icon icon="ri:search-line" class="_f-s-20 mt-0 text-muted" /></div>
                </span>
              </div>
            </div>













            <transition-group name="fade" class="row mt-4 mb-5">
              <div class="col-sm-12 mb-4" v-if="!loading && !computedResults.length" :key="0">
                <div class="card p-3" :class="'bg-'+pc['main_bg_color']">
                  <div class="card-body p-5 text-center border rounded _b-s-7 _b-dashed" :class="'border-'+pc['main_border_color']">
                    <h3 :class="'text-'+pc['main_title_color']">No results were found</h3>
                    <p class="m-0" :class="'text-'+pc['main_text_color']">Please adjust your filters</p>
                  </div>
                </div>
              </div>
              <div class="col-sm-4 mb-4" v-for="(item, item_i) in computedResults" :key="item.id">
                <div class="border border-light border-hover-primary _transition-2 bg-white" @click="openDetails(item)">
                  <div class="_p-t-100p position-relative _c-pointer" :style="'background-image: url(' + formatImage('/fm/revinre-store/clip art/trasnparent-b1g.png') + ')'">
                    <div class="position-absolute _pos-t-0 _pos-r-0 _pos-b-0 _pos-l-0 text-center p-2">
                      <img class="_h-m-100p _w-m-100p" :src="formatImage(item.thumbnail)" >
                    </div>
                  </div>
                  <div class="card-body border-top border-light">
                    <div class="float-right">
                      <div class="text-black font-weight-bold">{{ formatPrice(item.price) }}</div>
                    </div>
                    <div class="mb-2">
                      <span v-for="(color, color_i) in item.colors" :key="color_i" class="p-2 mr-2 d-inline-block rounded-circle" :style="'background-color:'+color"></span>
                    </div>
                    <div class="font-weight-bold text-black mb-2">{{ item.title }}</div>
                    <p class="small mb-2 overflow-hidden _h-m-65" v-html="item.description"></p>
                    <a class="btn btn-block btn-revinre">View details <Icon icon="ri:arrow-right-fill" class="m-0" /></a>
                  </div>
                </div>
              </div>
              
            </transition-group>
          </div>
        </div>

        <div v-if="pc['post_btn'] && pc['post_btn'].length" class="text-center">
          <a v-for="(btn, btn_i) in pc['post_btn']" :key="btn_i" v-if="btn['text'] || btn['pre_icon'] || btn['post_icon']" class="btn btn-lg mb-3 mx-3" :class="'btn-'+btn['color']" :href="btn['url']" target="_blank">
            <Icon v-if="btn['pre_icon']" :icon="btn['pre_icon']" height="20"></Icon>
            <span v-if="btn['pre_icon'] && btn['text']" class="border-left mx-3"></span>
            {{ btn['text'] }}
            <span v-if="btn['post_icon'] && btn['text']" class="border-left mx-3"></span>
            <Icon v-if="btn['post_icon']" :icon="btn['post_icon']" height="20"></Icon>
          </a>
        </div>

      </div>
    </div>
  </section>

</template>
